import { render, staticRenderFns } from "./MdocksForm.vue?vue&type=template&id=65524460"
import script from "./MdocksForm.vue?vue&type=script&lang=js"
export * from "./MdocksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports